import { Component, OnInit, HostListener } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NotifierService } from 'angular-notifier';
import { Router, NavigationEnd } from '@angular/router';
import { SearchCountryField, CountryISO } from 'ngx-intl-tel-input';
import { FormControl, Validators, FormArray, FormGroup } from '@angular/forms';
import { GlobalApiService } from 'src/app/services/global-api.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnInit {
  searchCountryField = SearchCountryField;
  countryISO = CountryISO;
  isProfilePage = false;
  first_name = '';
  last_name = '';
  email = new FormControl('', [Validators.email, Validators.required]);
  emailValid = false;
  firstChildEmailValid = false;
  secondChildEmailValid = false;
  firstChildFormControl = new FormControl('', [Validators.email]);
  secondChildFormControl = new FormControl('', [Validators.email]);
  // childrenEmail = new FormArray([
  //   new FormControl("", [Validators.email, Validators.required]),
  // ]);
  childrenEmail: FormArray = new FormArray(<any>[]);
  gender = '';
  role = '';
  notes = '';
  children: any[] = [];
  zip = '';
  address = '';
  error = false;
  submitClicked = false;
  updatedProfile = false;
  emailDisabled = false;
  mobileNumber: any;
  skypeId = '';
  apiCountryCode = '';
  apiMobileNumber = '';
  apiConstructedMobileNumber = '';
  mobileNumberError = '';
  profileAddChild = false;
  profileEnableMobile = false;
  courses = [];
  selectedCourses: any[] = [];
  otherCoursesSelected = false;
  requestedCourses = [];
  acceptedCourses: any[] = [];
  deletedCourses: number[] = [];
  accommodation: number = 1;
  countryCode = new FormControl('+1', [
    Validators.required,
    Validators.pattern(/^\+[1-9]\d{0,2}$/),
  ]);
  newMobileNumber = new FormControl('', [
    Validators.required,
    Validators.pattern(/^\d{7,15}$/),
  ]);
  private readonly notifier: NotifierService;
  constructor(
    private httpClient: HttpClient,
    notifierService: NotifierService,
    private router: Router,
    private globalApiService: GlobalApiService,
    private commonService: CommonService,
  ) {
    this.notifier = notifierService;
    this.router.events.subscribe((eves) => {
      if (eves instanceof NavigationEnd) {
        this.isProfilePage = /^#[/]profile/.test(window.location.hash);
        if (this.isProfilePage) {
          this.email.disable();
        }
      }
    });
  }

  ngOnInit() {
    this.globalApiService.getUser().subscribe(
      (response: any) => {
        console.log(response);
        this.first_name = response['first_name'] ? response['first_name'] : '';
        this.last_name = response['last_name'] ? response['last_name'] : '';
        // this.email = response["email"] ? response["email"] : "";
        if (response['email']) {
          this.emailDisabled = true;
          this.email.setValue(response['email']);
          this.email.disable();
        }
        this.gender = response['gender'] ? response['gender'] : '';
        this.role = response['role_id']
          ? JSON.stringify(response['role_id'])
          : '';
        this.accommodation = response['accommodation']
          ? response['accommodation']
          : 1;
        console.log(this.accommodation);
        this.notes = response['registration_request_note']
          ? response['registration_request_note']
          : '';
        this.skypeId = response['skype'] ? response['skype'] : '';
        this.zip = response['zipcode'] ? response['zipcode'] : '';
        this.address = response['address'] ? response['address'] : '';
        // console.log(JSON.parse(response["childs"]));
        const children = response['childs']
          ? JSON.parse(response['childs'])
          : [];
        children.forEach((child: any) => {
          this.addChild(child);
        });
        if (response['mobile']) {
          this.apiMobileNumber = response['mobile'];
          this.apiCountryCode = response['country'];
          this.apiConstructedMobileNumber = `${this.apiCountryCode} ${this.apiMobileNumber}`;
          console.log(response['mobile'], response['country']);
          this.newMobileNumber.setValue(response['mobile']);
          this.countryCode.setValue(response['country']);
        }
        this.requestedCourses = response['requested_courses'];
        this.fetchCourses();
      },
      (error) => {
        console.log(error);
        this.notifier.notify('error', 'Unable to fetch data');
      },
    );
  }

  fetchCourses() {
    this.globalApiService.getCourses().subscribe(
      (response: any) => {
        console.log(response);
        this.courses = response.data ? response.data : [];
        this.courses = this.courses.filter((course: any) => {
          return (
            this.acceptedCourses.findIndex((acceptedCourse: any) => {
              return course.courseId === acceptedCourse.courseId;
            }) < 0
          );
        });
        this.requestedCourses.forEach((course: any) => {
          if (course.status === 1) {
            this.acceptedCourses.push(course);
          } else if (course.status === 0) {
            const selectedCourse: any = JSON.parse(JSON.stringify(course));
            delete selectedCourse.status;
            this.selectedCourses.push(selectedCourse);
          } else {
            this.deletedCourses.push(course.courseId);
          }
        });
        this.courses = this.courses.filter((course: any) => {
          return (
            this.acceptedCourses.findIndex((acceptedCourse) => {
              return acceptedCourse.courseId === course.courseId;
            }) < 0
          );
        });
      },
      (error) => {
        console.log(error);
        this.notifier.notify('error', 'Unable to fetch courses');
      },
    );
  }

  // @HostListener("window:scroll", ["$event"])
  // onWindowScroll(e) {
  //   let element = document.querySelector("#role-select__header");
  //   if (window.pageYOffset > element.clientHeight / 3) {
  //     element.classList.add("role-select__header__whiteBackground");
  //   } else {
  //     element.classList.remove("role-select__header__whiteBackground");
  //   }
  // }

  validateEmail = () => {
    this.emailValid = (<HTMLInputElement>(
      document.getElementById('email')
    )).checkValidity();
  };

  onRoleUpdate = () => {
    for (let i = this.childrenEmail.controls.length - 1; i >= 0; i--) {
      console.log(i);
      this.childrenEmail.removeAt(i);
    }
    if ((this.role === '3' || this.role === '4') && !this.isProfilePage) {
      this.addChild(null);
    }
  };

  validateMobileNumber = (mobileNumber: any) => {
    if (mobileNumber) {
      let constructedMobileNumber = mobileNumber.number;
      if (constructedMobileNumber.indexOf(' ') > -1) {
        const newArray = constructedMobileNumber.split(' ');
        constructedMobileNumber = newArray.join('');
      }
      if (constructedMobileNumber.indexOf('-') > -1) {
        const newArray = constructedMobileNumber.split('-');
        constructedMobileNumber = newArray.join('');
      }
      if (
        constructedMobileNumber.length < 7 ||
        constructedMobileNumber === ''
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  onlyNumber(event: any, control: any) {
    event.preventDefault();
    const value = event.target.value;
    control.setValue(value.replace(/\D+/g, ''));
    console.log(control);
  }

  constructMobileNumber = (mobileNumber: any) => {
    let constructedMobileNumber = mobileNumber.number;
    if (constructedMobileNumber.indexOf(' ') > -1) {
      const newArray = constructedMobileNumber.split(' ');
      constructedMobileNumber = newArray.join('');
    }
    if (constructedMobileNumber.indexOf('-') > -1) {
      const newArray = constructedMobileNumber.split('-');
      constructedMobileNumber = newArray.join('');
    }
    return constructedMobileNumber;
  };

  addChild = (childInfo: any) => {
    console.log(
      this.children.length + this.childrenEmail.controls.length,
      childInfo,
    );
    const firstName: FormControl = new FormControl(
      childInfo?.first_name || '',
      [Validators.required],
    );
    const lastName: FormControl = new FormControl(childInfo?.last_name || '', [
      Validators.required,
    ]);
    const email: FormControl = new FormControl(childInfo?.email || '', [
      Validators.email,
      Validators.required,
    ]);
    const phone: FormControl = new FormControl(childInfo?.mobile || '', [
      Validators.required,
      Validators.pattern(/^\d{7,15}$/),
    ]);
    const countryCode: FormControl = new FormControl(
      childInfo?.country || '+1',
      [Validators.required, Validators.pattern(/^\+[1-9]\d{0,2}$/)],
    );
    const child: FormGroup = new FormGroup({
      firstName,
      lastName,
      email,
      phone,
      countryCode,
    });

    this.childrenEmail.push(child);
  };

  removeChild = (index: number) => {
    // if (this.children.length === 2) {
    //   this.children.splice(index, 1);
    // }
    this.childrenEmail.removeAt(index);
  };

  removeChildBlock = (index: number) => {
    if (this.children.length + this.childrenEmail.controls.length > 1) {
      this.children.splice(index, 1);
    }
  };

  trackByIndex = (index: any) => {
    return index;
  };

  logout() {
    // localStorage.clear();
    // this.router.navigate(['']);
    this.commonService.logout();
  }

  spaceValidator = (event: any) => {
    let value = event.target.value.split(' ');
    event.target.value = value.join('');
  };

  zipCodeValidator = (event: any) => {
    let value = /^[0-9]*$/.test(event.target.value);
    console.log(value);
    if (!value) {
      event.target.value = event.target.value.slice(0, -1);
    }
  };

  enableMobile() {
    this.profileEnableMobile = true;
  }

  isOthersSelected(courses: any) {
    this.otherCoursesSelected =
      courses.value.findIndex(
        (course: any) => course.courseName.toLowerCase() === 'other',
      ) >= 0;
  }

  isChildValid = (index: number) => {
    let isChildEmailValid =
      index === 0
        ? this.firstChildEmailValid
        : index === 1
          ? this.secondChildEmailValid
          : false;
    const child: any = this.children[index];
    if (
      this.error &&
      (child === '' || child.trim() === '' || !isChildEmailValid)
    ) {
      return true;
    }
    return false;
  };

  onSubmit = () => {
    if (!this.submitClicked) {
      this.submitClicked = true;
      this.error = false;
      this.mobileNumberError = '';
      let errorOccurred = false;
      this.countryCode.setValue(this.countryCode.value?.trim() ?? '');
      this.newMobileNumber.setValue(this.newMobileNumber.value?.trim() ?? '');


      if (this.countryCode.invalid || this.newMobileNumber.invalid) {
        errorOccurred = true;
      }
      if (this.email.invalid) {
        errorOccurred = true;
      } else if (this.last_name === '' || this.last_name.trim() === '') {
        errorOccurred = true;
      } else if (this.first_name === '' || this.first_name.trim() === '') {
        errorOccurred = true;
      } else if (this.gender === '') {
        errorOccurred = true;
      } else if (this.role === '') {
        errorOccurred = true;
      } else if (
        this.notes === '' ||
        (this.notes.trim() === '' && !this.isProfilePage)
      ) {
        errorOccurred = true;
      }
      // else if (this.role === "4") {
      //   if (
      //     this.isProfilePage &&
      //     this.profileAddChild &&
      //     this.childrenEmail.invalid
      //   ) {
      //     errorOccurred = true;
      //   } else if (!this.isProfilePage && this.childrenEmail.invalid) {
      //     errorOccurred = true;
      //   }
      //   // if (
      //   //   !this.firstChildEmailValid ||
      //   //   this.children[0] === "" ||
      //   //   this.children[0].trim() === "" ||
      //   //   (this.children.length > 1 &&
      //   //     (!this.secondChildEmailValid ||
      //   //       this.children[0] === "" ||
      //   //       this.children[0].trim() === ""))
      //   // ) {
      //   //   errorOccurred = true;
      //   // }
      // }
      if (this.role === '3' || this.role === '4') {
        if (
          this.role === '3' &&
          this.selectedCourses.length + this.acceptedCourses.length === 0
        ) {
          errorOccurred = true;
        }
        for (let i = 0; i < this.childrenEmail.controls.length; i++) {
          const child: any = this.childrenEmail.controls[i];

          const {firstName, lastName, email, countryCode, phone} = child.controls;

          countryCode.setValue(countryCode.value?.trim() ?? '');
          phone.setValue(phone.value?.trim() ?? '');

          if (firstName.invalid || firstName.value.trim() === '') {
            errorOccurred = true;
            break;
          }

          if (lastName.invalid || lastName.value.trim() === '') {
            errorOccurred = true;
            break;
          }

          if (email.invalid) {
            errorOccurred = true;
            break;
          }

          if (countryCode.invalid) {
            errorOccurred = true;
            break;
          }

          if (phone.invalid) {
            errorOccurred = true;
            break;
          }
        }
      }
      console.log(errorOccurred);
      if (!errorOccurred) {
        const constructedChildren: any[] = [...this.children];
        if (this.role === '3' || this.role === '4') {
          for (let i = 0; i <= this.childrenEmail.controls.length - 1; i++) {
            const childEmail: any = this.childrenEmail.controls[i];
            constructedChildren.push({
              first_name: childEmail['controls']['firstName'].value.trim(),
              last_name: childEmail['controls']['lastName'].value.trim(),
              email: childEmail['controls']['email'].value,
              // mobile: this.constructMobileNumber(
              //   childEmail['controls']['phone'].value
              // ),
              // country: childEmail['controls']['phone'].value.dialCode,
              mobile: childEmail['controls']['phone'].value,
              country: childEmail['controls']['countryCode'].value,
            });
          }
        }
        console.log("Constructed children:", constructedChildren);
        let requestedCourses: any[] = [];
        if (this.role !== '2') {
          console.log(this.selectedCourses);
          this.selectedCourses.map((course: any) =>
            requestedCourses.push({ courseId: course.courseId, status: 0 }),
          );
          this.deletedCourses.forEach((courseId) => {
            const index = requestedCourses.findIndex((course) => {
              return course.courseId === courseId;
            });
            if (index < 0) {
              requestedCourses.push({ courseId, status: 2 });
            }
          });
          if (this.acceptedCourses.length > 0) {
            requestedCourses = requestedCourses.concat(this.acceptedCourses);
          }
          console.log(requestedCourses);
        }
        const data: any = {
          first_name: this.first_name.trim(),
          last_name: this.last_name.trim(),
          gender: parseInt(this.gender),
          skype: this.skypeId ? this.skypeId : '',
          email: this.email.value?.trim(),
          role_id: parseInt(this.role),
          registration_request_note: this.notes.trim(),
          zipcode: this.zip,
          address: this.address,
          childs:
            (this.role === '3' || this.role === '4') &&
            constructedChildren.length > 0
              ? constructedChildren
              : '',
          requested_courses: requestedCourses.sort(),
          accommodation: this.role === '3' ? this.accommodation : null,
        };
        // if (constructedMobileNumber) {
        //   // data['mobile'] = constructedMobileNumber;
        //   // data['country'] = countryCode;
        // } else {
        //   // data['mobile'] = this.apiMobileNumber;
        //   // data['country'] = this.apiCountryCode;
        // }
        data['mobile'] = this.newMobileNumber.value;
        data['country'] = this.countryCode.value;
       
        this.httpClient
          .put(
            this.isProfilePage ? '/api/update_profile' : '/api/update_user',
            data,
            {
              headers: {
                Authorization: 'Bearer ' + localStorage['accessToken'],
              },
              responseType: 'json',
            },
          )
          .subscribe(
            (response) => {
              // console.log(response);
              // localStorage.roleId = this.role;
              // localStorage.status = "2";
              this.submitClicked = false;
              // this.router.navigate(["/dashboard"]);
              if (!this.isProfilePage) {
                localStorage.clear();
                this.updatedProfile = true;
                this.notifier.notify(
                  'success',
                  'Profile updated successfully. Redirecting to login...',
                );

                setTimeout(() => {
                  this.router.navigateByUrl('/sign-in');
                }, 5000);
              } else {
                // this.children = constructedChildren;
                // for (
                //   let i = this.childrenEmail.controls.length - 1;
                //   i >= 0;
                //   i--
                // ) {
                //   console.log(i);
                //   this.childrenEmail.removeAt(i);
                // }
                // this.childrenEmail.controls.push(
                //   new FormControl("", [Validators.email, Validators.required])
                // );
                // this.profileAddChild = false;
                this.notifier.notify('success', 'Successfully Updated profile');
              }
            },
            (error) => {
              console.log(error);
              this.submitClicked = false;
              let errorSent = false;
              console.log(error['error']);
              if (error['error']) {
                console.log(error['error']['msg']);
                if (error['error']['msg'] === 'email_id_should_be_unique') {
                  errorSent = true;
                  this.notifier.notify('error', 'Email ID already exists');
                }
              }
              if (!errorSent) {
                this.notifier.notify('error', 'Unable to update profile');
              }
            },
          );
      } else {
        this.error = errorOccurred;
        this.submitClicked = false;
      }
    }
  };
  onCancel() {
    if (!this.isProfilePage) localStorage.clear();
    this.router.navigate([this.isProfilePage ? '/' : '/sign-in']);
  }

  getControl(key: string, index: number) {
    const control: any = this.childrenEmail.controls[index];
    return control.controls[key];
  }
}
